import $ from 'jquery';
import '../vendor/slick';
import { register } from '@shopify/theme-sections';

register('top-banner', {
  onLoad() {
    this.$container = $(this.container);
    this.namespace = `.${this.id}`;
    this.$slideshow = $('[data-top-banner]', this.$container);

    this.handleResize();
    $(window).on('resize', this.handleResize.bind(this));
  },

  onDesktop() {
    if (this.$slideshow.hasClass('slick-initialized')) {
      this.$slideshow.slick('unslick');
    }
  },

  onMobile() {
    if (!this.$slideshow.hasClass('slick-initialized')) {
      this.$slideshow.slick({
        arrows: false,
        infinite: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: this.$slideshow[0].dataset.autoplaySpeed,
        cssEase: 'ease',
        slidesToShow: 1,
        slidesToScroll: 1
      });
    }
  },

  handleResize() {
    const isMobile = window.innerWidth <= 799;
    if (isMobile) {
      this.onMobile();
    } else {
      this.onDesktop();
    }
  },

  onUnload() {
    $(window).off('resize', this.handleResize.bind(this));
  }
});
